$(() => {
  const nurses_on_staff = () => {
    const number_of_employees = parseInt($('#number-of-employees').val().replace(',', ''), 10);

    return Math.round(0.15 * number_of_employees);
  };

  const run = () => {
    if ($('#nurses-on-staff-overridden').val() === '0') {
      $('#nurses-on-staff').val(nurses_on_staff());
      $('#nurses-on-staff').change();
    }
  };

  run();

  $('#number-of-employees').blur(() => {
    run();
  });

  $('#number-of-employees').change(() => {
    run();
  });

  $('#nurses-on-staff').blur(() => {
    $('#nurses-on-staff-overridden').val('1');
  });
});
